let $ = require("jquery");

// default
$('.dd-product__images__list__item--1').addClass('is-active');
$('.dd-product__image__item--1').addClass('is-active');

// Navigation
$('.dd-product__images__list__item').each(function () {
  let $self = $(this);
  $self.on('click', function (event) {
    let $id = $(this).attr("data-image");
    $('.dd-product__images__list__item').removeClass('is-active');
    $('.dd-product__images__list__item--' + $id).addClass('is-active');
    $('.dd-product__image__item').removeClass('is-active');
    $('.dd-product__image__item--' + $id).addClass('is-active');
  });
});








$(".product__image").each(function() {
  let $image_static = $(".product__image__static", this);
  let $image_360 = $(".product__image__360", this);
  let active = "static";

  let $trigger = $(".product__image__trigger", this).on("click", function() {
    $trigger.removeClass("is-active");

    let $self = $(this).addClass("is-active");
    let type = $self.attr("data-type");
    let i = $image_360.data("threeSixtyInstance");

    $('.images-360-trigger').attr("data-type", 'static');


    if (type == "static") {
      $image_360.hide();
      $image_static.show();
      i.stop();

      $('.images-360-trigger').removeAttr("data-type", 'static').attr("data-type", '360');
      $('.images-360-trigger').removeClass('is-active');
    } else {
      i.play(100, 1);
      setTimeout(i.stop, 1000);
      $image_360.show();
      $image_static.hide();

      $('.images-360').on('click', function() {
        i.stop();
      });

      $('.images-360-trigger.is-active').on('click', function() {
        $('.product__image__triggers .product__image__trigger').first().addClass('is-active');
        $('.field--name-field-dd-product-image .field__item').removeClass('active').first().addClass('active');
      });
    }
  });
});

$(".product__image__triggers").each(function() {
  let $self = $(this);
  let $items = $self.parents(".field__items").find(".field__item");
  let $triggers = $self.find(".product__image__trigger");

  $self.on("click", ".product__image__trigger", function(event) {
    let index = $(this).index();
    $items
      .removeClass("active")
      .eq(index)
      .addClass("active");
    $triggers
      .removeClass('is-active')
      .eq(index)
      .addClass('is-active');
  });
});


// FURTHER FILTER
// $(document).ready(function() {
//   var wrapper = $('.dd-filter__select');
//   // wrapper.append('<div class="product__filter__further">+ Weitere Filter</a>');
//   var furtherFilterTrigger = $('.product__filter__further');
//   furtherFilterTrigger.click(function() {
//     wrapper.toggleClass('is-active');
//     if (wrapper.hasClass('is-active')) {
//       furtherFilterTrigger.text('- Weniger Filter');
//     } else {
//       furtherFilterTrigger.text('+ Weitere Filter');
//     }
//   });
// });
